import request from '@/utils/request'

export function loadUserInfo () {
    return request({
        url: '/auth/getUserInfo',
        method: 'get'
    })
}
export function loadProvinceData (params) {
    return request({
        url: '/dict/region/list',
        params: params,
        method: 'get'
    })
}
export function loadAddress () {
    return request({
        url: '/points/sys/user/address/list',
        method: 'get'
    })
}
export function insertAddress (data) {
    return request({
        url: '/points/sys/user/address/insert',
        data: data,
        method: 'post'
    })
}export function updateAddress (data) {
    return request({
        url: `/points/sys/user/address/update/${data.id}`,
        data: data,
        method: 'post'
    })
}
export function delAddress (id) {
    return request({
        url: `/points/sys/user/address/delete/${id}`,
        method: 'post'
    })
}
export function loadPoints () {
    return request({
        url: `/points/sys/user/point/getPointsCollect`,
        method: 'get'
    })
}
export function loadPointsRecord (params) {
    return request({
        url: `/points/sys/user/record/page`,
        params: params,
        method: 'get'
    })
}
// 搜索供应商积分总分
export function supplierJifenAll (params) {
    return request({
        url: `/points/sys/user/point/page`,
        params: params,
        method: 'get'
    })
}

export function loadOrderPage (params) {
    return request({
        url: `/points/order/queryPointsOrderPage`,
        data: params,
        method: 'post'
    })
}
// 收货
export function takeDeliveryOfGoods (params) {
    return request({
        url: `/points/order/pointsOrderCompleted/${params}`,
        method: 'get'
    })
}
export function loadOrderDetail (id) {
    return request({
        url: `/points/order/queryPointOrderDetail/${id}`,
        method: 'get'
    })
}
export function loadPlatformOrderDetail (id) {
    return request({
        url: `/points/orderAcquire/detail/${id}`,
        method: 'get'
    })
}
export function loadPlatformOrderDetail2 (id) {
    return request({
        url: `/points/sys/user/point/queryPointsOrderItem/${id}`,
        method: 'get'
    })
}

export function advertisingReport (data) {
    return request({
        url: `/advert/recv/save`,
        method: 'post',
        data: data
    })
}
